import { format } from "date-fns";
import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import OrderSummaryItems from "../../../Common/Components/OrderSummaryItems";
import TotalPriceCard from "../../../Common/Components/SummaryTotalPriceCard";
import { TitleHeader } from "../../../Common/Components/TitleHeader";
import useCartTotal from "../../../Common/Hooks/useCartTotal";
import useTax from "../../../Common/Hooks/useTax";
import { baseUrl } from "../../../Services/Axios";
import { fetchServices } from "../../../Services/CartService";
import {
  updateOrder as adminOrderUpdate,
  fetchOrderDetails as fetchAdminOrderDetails,
} from "../../Services/OrderService";

export const OrderReview = () => {
  const [loading, setLoading] = React.useState(false);
  const [deliveryType, setDeliveryType] = React.useState(null);
  const [services, setServices] = React.useState([]);
  const [items, setItems] = React.useState([]);
  const [submitting, setSubmitting] = React.useState(false);
  const [paymentMethod, setPaymentMethod] = React.useState("cash_on_delivery"); //digital_payment // card_on_delivery;
  const [deliveryOverride, setDeliveryOverride] = React.useState(null);
  const [lessDc, setLessDc] = React.useState(false);
  const bookingType = useSelector((x) => x.BookingType);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const deliveryTypes = useSelector((x) => x.OrderTypes);
  const cart = useSelector((x) => x.Cart);
  const pickupDate = useSelector((x) => x.PickupDate);
  const deliveryDate = useSelector((x) => x.DeliveryDate);
  const zone = useSelector((x) => x.Zone);
  const coupon = useSelector((x) => x.Coupon);
  const address = useSelector((x) => x.Addresses);
  const note = useSelector((x) => x.Note);
  const customer = useSelector((x) => x.Customer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [subtotal, tax, discount, deliveryCharge, total, grossTotal, referralDiscount] =
    useTax(deliveryType, { deliveryChargeOverride: deliveryOverride });

  const [open, setOpen] = React.useState({});
  const [order, setOrder] = React.useState(null);
  const params = useParams();

  const consumerRefCode = customer?.referral_reward?.consumer_referral_code;

  React.useEffect(() => {
    setLoading(true);
    if (params?.id)
      fetchAdminOrderDetails(params?.id).then(
        (res) => {
          console.clear();
          // console.log(res);
          const data = res.data;
          if (data) {
            setOrder(data);
            setPaymentMethod(data.payment_method);
            setDeliveryOverride(data.delivery_charge);
          }
        },
        (er) => {
          console.warn(er);
          toast.error("Something went wrong while fetching order details.");
        }
      );
  }, [params]);

  React.useEffect(() => {
    if (!cart || (cart && cart.length <= 0)) {
      navigate("/store/orders", { replace: true });
    }
  }, [cart, navigate]);

  React.useEffect(() => {
    setDeliveryType(deliveryTypes.find((x) => x.id == orderTypeId));
    fetchServices(50, 1, orderTypeId).then(
      (res) => {
        setServices(res);
      },
      (err) => console.warn(err, "err while fetching services...")
    );
  }, [orderTypeId, deliveryTypes]);

  React.useEffect(() => {
    if (services.length !== 0 && cart.length !== 0) {
      setLoading(true);
      const temp = cart.reduce((result, item) => {
        const key = item.serviceId;
        setOpen((prev) => ({
          ...prev,
          [key]: true,
        }));
        if (!result[key]) {
          result[key] = {
            services_id: key,
            service: services.find((s) => s.id === key)?.name,
            open: true,
            items: [],
          };
        }
        const {
          laundry_item_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          details_id,
          free_items,
          bundle_free,
          bundle_buy,
          is_bundle_active,
          item_note,
        } = item;
        result[key].items.push({
          laundry_item_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          details_id,
          free_items,
          bundle_free,
          bundle_buy,
          is_bundle_active,
          item_note,
        });
        return result;
      }, {});
      const tempTemp = Object.values(temp);
      const anotherTemp = [];
      for (let i = 0; i < tempTemp.length; i++) {
        const x = tempTemp[i];
        anotherTemp.push(x);
      }
      setItems(anotherTemp);
      setLoading(false);
    }
  }, [cart, services]);

  const placeOrder = () => {
    if (!loading && !submitting && items.length !== 0) {
      setSubmitting(true);
      const payload = {
        order_process: order?.order_process,
        is_hub_store:
          order?.is_hub_store != undefined
            ? Boolean(order?.is_hub_store)
            : undefined,
        order_status: order?.order_status,
        order_id: order?.id,
        payment_status: "unpaid",
        delivery_date: format(deliveryDate?.date, "yyyy-MM-dd HH:mm:ss.SSS"),
        pickup_date: format(pickupDate?.date, "yyyy-MM-dd HH:mm:ss.SSS"),
        payment_method: paymentMethod,
        platform: order?.platform,
        consumer_referral_code: consumerRefCode,
        referral_discount: referralDiscount,
        pickup_coordinates: address?.pickup_coordinates,
        destination_coordinates: address?.destination_coordinates,
        pickup_address: address?.pickup_address,
        destination_address: address?.destination_address,
        bar_code: "",
        order_pickup_time_slot_id: pickupDate?.slot?.id,
        order_type_id: order?.laundry_delivery_type_id,
        order_delivery_time_slot_id: deliveryDate?.slot?.id,
        laundry_delivery_type_id: order?.laundry_delivery_type_id,
        service_id: 19,
        category_id: 1,
        // delivery_charge: deliveryType?.charge,
        delivery_charge: deliveryOverride ?? deliveryType?.charge,
        pickup_schedule_at: format(pickupDate?.date, "yyyy-MM-dd HH:mm:ss.SSS"),
        delivery_schedule_at: format(
          deliveryDate?.date,
          "yyyy-MM-dd HH:mm:ss.SSS"
        ),
        pending: "",
        distance: 10.5,
        note,
        order_pickup_time_slot_date: format(
          pickupDate?.date,
          "yyyy-MM-dd HH:mm:ss.SSS"
        ),
        order_delivery_time_slot_date: format(
          deliveryDate?.date,
          "yyyy-MM-dd HH:mm:ss.SSS"
        ),
        laundryZoneId: zone,
        coupon_code: coupon?.code || null,
        order_pickup_time_slot: `${pickupDate?.slot?.start_time} - ${pickupDate?.slot?.end_time}`,
        order_delivery_time_slot: `${deliveryDate?.slot?.start_time} - ${deliveryDate?.slot?.end_time}`,
        cart: items,
        tax_amount: tax,
        order_amount: total,
        booking_type: bookingType,
      };
      const afterOrder = (order) => {
        setSubmitting(false);
        // console.log(order);
        if (paymentMethod !== "digital_payment") {
          navigate(`/admin/orders`, {
            replace: true,
          });
        }
        dispatch({ type: "setCart", payload: [] });
        dispatch({ type: "setOrderType", payload: null });
        dispatch({ type: "setOrderTypeId", payload: null });
        dispatch({ type: "setBookingType", payload: null });
        dispatch({ type: "setService", payload: null });
        dispatch({ type: "setCategory", payload: null });
        dispatch({ type: "setDeliveryDate", payload: null });
        dispatch({ type: "setPickupDate", payload: null });
        dispatch({ type: "setCoupon", payload: null });
        dispatch({ type: "setAddresses", payload: null });
        dispatch({ type: "setNote", payload: null });
      };
      adminOrderUpdate({...payload, lessDc: lessDc}).then(
        (res) => {
          if (paymentMethod === "digital_payment") {
            // payment(res, afterOrder);
            window.location.replace(
              `${baseUrl}/payfast-payment?group_id=${res?.order_id}`
            );
          }
          afterOrder(res);
        },
        (er) => {
          setSubmitting(false);
          if (er && er.errors && er.errors.length !== 0) {
            console.log(er);
            er.errors.forEach((x) => {
              toast.error(x.message);
            });
          }
        }
      );
    }
  };

  const orderStatus = order?.order_status || "";

  const handleDeliveryOverrideChange = (value) => {
  setDeliveryOverride(value);
  // lessDc = was originally > 0, now set to 0
  if (Number(value) === 0 && Number(deliveryCharge) > 0) {
    setLessDc(true);
  } else {
    setLessDc(false);
  }
};

  return (
    <>
      <TitleHeader
        title={"Order Review"}
        subtitle={
          "Double-check your details for a seamless, spotless laundry experience!"
        }
      />
      <div className="container">
        <div className="row justify-content-center py-4">
          <div className="col-xl-6 col-lg-7 col-md-10 col-12">
            {/* Pricing */}
            {loading ? (
              <div className="w-100 text-center py-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <OrderSummaryItems
                  items={items}
                  open={open}
                  setOpen={setOpen}
                />
                <div className="card  mb-3">
                  {/* {deliveryTypes ? (
                    <TotalPriceCard deliveryType={deliveryTypes[orderTypeId]}
                    referralPercent={Number(order?.referral_reward?.reward_amount ?? 0)} />
                  ) : null} */}
                  {deliveryTypes ? (
                  <TotalPriceCard
                      deliveryType={deliveryTypes[orderTypeId]}
                      referralPercent={Number(order?.referral_reward?.reward_amount ?? 0)}
                      editableDelivery={true}          // ✅ only review passes true
                      deliveryOverride={deliveryOverride}
                      onDeliveryOverrideChange={handleDeliveryOverrideChange}
                      orderStatus={orderStatus}
                    /> 
                  ) : null }
                </div>
                {/* Dates */}
                <div className="card  mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold">Scheduled Dates</h5>

                    <div className="app-dates-container border border-gray rounded mt-4">
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute", top: "-12px" }}
                          className="bg-white px-2"
                        >
                          Pickup
                        </small>
                        <div className="d-flex align-items-center py-3 border-r border-gray">
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {pickupDate?.date
                            ? format(pickupDate.date, "eee, do MMM")
                            : "Date"}
                          {pickupDate?.date && pickupDate?.slot ? <br /> : "/"}
                          {pickupDate?.slot
                            ? `${pickupDate?.slot?.start_time} - ${pickupDate?.slot?.end_time}`
                            : "Time"}
                        </div>
                      </div>
                      <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                        &nbsp;
                      </div>
                      <hr className="w-100 my-1 d-block d-md-none" />
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute" }}
                          className="bg-white px-2 app-dates-delivery-label"
                        >
                          Delivery
                        </small>
                        <div className="d-flex align-items-center py-3">
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {deliveryDate?.date
                            ? format(deliveryDate.date, "eee, do MMM")
                            : "Date"}
                          {deliveryDate?.date && deliveryDate?.slot ? (
                            <br />
                          ) : (
                            "/"
                          )}
                          {deliveryDate?.slot
                            ? `${deliveryDate?.slot?.start_time} - ${deliveryDate?.slot?.end_time}`
                            : "Time"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Payment Method */}
                <div className="card  mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold mb-3">Payment Method</h5>
                    <div
                      className="row cursor-pointer align-items-center py-3"
                      onClick={() => {
                        if (order?.payment_status !== "paid")
                          setPaymentMethod("cash_on_delivery");
                      }}
                    >
                      <div className="col-11 d-flex align-items-center justify-content-between h-100">
                        <div className="d-flex align-items-center">
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/cash-on-delivery.png"}
                            style={{
                              height: "48px",
                              width: "48px",
                              objectFit: "contain",
                            }}
                            className={`${
                              paymentMethod === "cash_on_delivery"
                                ? "selected-payment-method"
                                : ""
                            }`}
                            alt=""
                          />
                          <h6 className="ms-2 mb-0">Cash On Delivery</h6>
                        </div>
                        {paymentMethod === "cash_on_delivery" ? (
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                            style={{ width: "22px" }}
                            alt=""
                          />
                        ) : null}
                      </div>
                    </div>
                    <hr
                      className="border-1 my-0"
                      style={{ borderStyle: "doted" }}
                    />
                    <div
                      className="row cursor-pointer align-items-center py-3"
                      onClick={() => {
                        if (order?.payment_status !== "paid")
                          setPaymentMethod("card_on_delivery");
                      }}
                    >
                      <div className="col-11 d-flex align-items-center justify-content-between h-100">
                        <div className="d-flex align-items-center">
                          <img
                            src={process.env.PUBLIC_URL +"/assets/images/card-on-delivery.png"}
                            style={{
                              height: "48px",
                              width: "48px",
                              objectFit: "contain",
                            }}
                            className={`${
                              paymentMethod === "card_on_delivery"
                                ? "selected-payment-method"
                                : ""
                            }`}
                            alt=""
                          />
                          <h6 className="ms-2 mb-0">Card on Delivery</h6>
                        </div>
                        {paymentMethod === "card_on_delivery" ? (
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                            style={{ width: "22px" }}
                            alt=""
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Addresses */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">Address</span>
                    <div className="row">
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-circle-dot"
                          style={{ color: "#32b6e9" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Pickup Address</h6>
                        <p className="m-0">
                          {address?.pickup_address
                            ? `${address?.pickup_address?.addressLine1}, ${address?.pickup_address?.addressLine2}, ${address?.pickup_address?.area}, ${address?.pickup_address?.area_phase}`
                            : "Select address"}
                        </p>
                        <hr style={{ borderStyle: "doted" }} />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-location-dot text-primary"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Delivery Address</h6>
                        <p className="m-0">
                          {address?.destination_address
                            ? `${address?.destination_address?.addressLine1}, ${address?.destination_address?.addressLine2}, ${address?.destination_address?.area}, ${address?.destination_address?.area_phase}`
                            : "Select address"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Note */}
                {note && note !== "" ? (
                  <div className="card  mb-3">
                    <div className="card-body">
                      <h5 className="fw-bold mb-3">
                        Order Note / Instructions.
                      </h5>
                      <p>{note}</p>
                    </div>
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="container-fluid bg-white">
        <div
          className="row justify-content-center"
          style={{ padding: "20px 0px" }}
        >
          <div
            className="d-flex col-lg-6 col-md-7 col-12 justify-content-center"
            style={{ columnGap: "20px" }}
          >
            <button
              className="service-btn next"
              disabled={loading || submitting}
              onClick={() => placeOrder()}
            >
              {submitting ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
              ) : null}
              <span className="fw-semibold">Update Order</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
